module.exports = __webpack_public_path__ + "img/Blue-Center@2x.e3654dfb.png";